import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React, { Fragment } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';
import { IOrderBump, IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { CurrencyFormat } from '../../CurrencyFormat';
import { getCdnImage } from 'functions';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  orderBumpProducts: IOrderBump[];
  orderBumpProductsSelected: string[];
  productsIds: string[];
}

@WithStyles(() => ({
  component: {
    border: '2px dashed #009358',
    marginTop: '16px',
    width: '100%',
    '& .orderBumpOffer': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      padding: '8px',
      '& .productImage': {
        height: '70px',
        margin: '0 8px 0 0',
        minHeight: '70px',
        minWidth: '70px',
        width: '70px',
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }
      },
      '& .orderBumpDescription': {
        '& h1': {
          color: '#009358',
          fontSize: '0.888rem',
          margin: 0,
          textAlign: 'left'
        },
        '& span': {
          color: '#596375',
          fontSize: '0.777rem',
          '& .theme-orderbump-highlight, & .theme-orderbump-highlight span': {
            color: '#009358',
            fontWeight: 'bold'
          }
        }
      }
    },
    '& .orderBumpSelector': {
      backgroundColor: '#009358',
      cursor: 'pointer',
      padding: '0 8px',
      '& label': {
        transform: 'translate(0, 0) scale(1)',
        whiteSpace: 'normal'
      },
      '& span': {
        color: '#FFF',
        fontSize: '0.7rem',
        fontWeight: 'bold'
      }
    }
  }
}))
export default class OrderBump extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      orderBumpProducts: null,
      orderBumpProductsSelected: [],
      productsIds: []
    };
  }

  componentDidMount() {
    cartService
      .getCart()
      .filter((cart: IProductData) => !!cart)
      .bindComponent(this)
      .subscribe((cart: IProductData) => {
        this.setState({ orderBumpProducts: cart.orderBump });

        const productsIds = cart.products.map(p => p.id.toString());
        this.setState({ productsIds });
      });
  }

  addOrderBump = (event: React.FormEvent<HTMLInputElement>) => {
    const orderBumpProductsSelected = JSON.parse(JSON.stringify(this.state.orderBumpProductsSelected));
    const productId = event.currentTarget.value;

    if (event.currentTarget.checked) {
      orderBumpProductsSelected.push(productId);
    }

    if (!event.currentTarget.checked) {
      const index = orderBumpProductsSelected.indexOf(productId);
      orderBumpProductsSelected.splice(index, 1);
    }

    this.setState({ orderBumpProductsSelected });

    cartService
      .setOrderBumps(orderBumpProductsSelected)
      .loader()
      .subscribe(data => {
        console.log(data);
      });
  };

  render() {
    if (!this.state || !this.state.orderBumpProducts) {
      return null;
    }

    const { orderBumpProductsSelected } = this.state;
    const { orderBumpProducts, productsIds } = this.state;

    const image = getCdnImage(orderBumpProducts[0].logo);

    return (
      <Fragment>
        {orderBumpProducts.slice(0, 1).map((product: IOrderBump) => (
          <div className={`${this.props.classes.component} theme-orderbump`} key={product.contentId}>
            <div className='orderBumpOffer'>
              <div className='productImage'>
                {image &&
                  <img src={image} />
                }
              </div>
              <div className="orderBumpDescription">
                <h1 className="theme-orderbump-highlight"><Translate term='Oferta Imperdível' /></h1>
                <span>
                  <Translate
                    term="Adquira também por apenas {price} o produto {product}"
                    properties={{
                      price: <span className="theme-orderbump-highlight"><CurrencyFormat value={product.price} /></span>,
                      product: <span className="theme-orderbump-highlight">{product.title}</span>
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="orderBumpSelector theme-orderbump-selector">
              <FormControlLabel
                control={
                  <Checkbox
                    id={'chk-check-order-bump'}
                    className="orderBumpCheckbox"
                    value={String(product.contentId)}
                    checked={
                      orderBumpProductsSelected.includes(String(product.contentId)) ||
                      productsIds.includes(String(product.contentId))
                    }
                    onChange={this.addOrderBump}
                  />
                }
                label={<Translate term="Sim, quero adicionar esta oferta em minha compra" />}
              />
            </div>
          </div>
        ))}
      </Fragment>
    );
  }
}
